const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/**
 * Validates an email against EMAIL_REGEX.
 *
 * @param email address to validate
 * @returns {*} null if email is valid or validation error message if it isn't
 */
export function validateEmail(email) {
  const mimeMail = email.match(/("[^"]*?")?.*?<([^>]+?)>$/);
  const emailToValidate = mimeMail ? mimeMail[2] : email;
  return EMAIL_REGEX.test(emailToValidate) ? null : 'Please include an \'@\' in the email address.';
}
